import React from 'react';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';

import styles from './text.module.scss';

export default ({ content, type }) => {
  const parsedHtml = ReactHtmlParser(content, {
    transform: function(node) {
      if (node.type === 'tag' && node.name === 'img') {
        node.attribs = {
          ...node.attribs,
          src: node.attribs.src + '?w=1170',
          srcset: `${node.attribs.src}?w=1920 1920w, ${
            node.attribs.src
          }?w=1170 1170w, ${node.attribs.src}?w=768 768w, ${
            node.attribs.src
          }?w=640 640w, ${node.attribs.src}?w=360 360w`,
          sizes: '(max-width: 1170px) 100vw, 1170px',
        }

        return convertNodeToElement(node)
      }
    },
  })

  return <div className={`${styles.text} ${styles[type]}`}>{parsedHtml}</div>
}
